module.exports = __webpack_public_path__ + "img/cultura_mobile.c341d143.png";